import type {Command, EditorView} from '@codemirror/view'

import {applyFormatting, getExistingFormatting, inlineFormatter, removeFormattingAtSelection} from './format-utils'

export const formatBold: Command = (view: EditorView) => {
  return inlineFormatter(view, 'strong')
}

export const formatItalic: Command = (view: EditorView) => {
  return inlineFormatter(view, 'emphasis')
}

export const formatInlineCode: Command = (view: EditorView) => {
  return inlineFormatter(view, 'inlineCode')
}

export const formatLink: Command = (view: EditorView) => {
  if (!view.hasFocus) view.focus()

  const existingFormattedNodes = getExistingFormatting(view, 'link')

  if (existingFormattedNodes.length > 0) {
    removeFormattingAtSelection(view, existingFormattedNodes)
  } else {
    // Put the selection inside the parentheses so users can efficiently paste a URL
    const customRangePosition = (_from: number, to: number) => to + 3
    applyFormatting(view, 'link', customRangePosition)
  }

  return true
}

export const formatStrikethrough: Command = (view: EditorView) => {
  return inlineFormatter(view, 'delete')
}
